module.exports = __webpack_public_path__ + "img/type_end2.a76f0aa7.png";